import moment from "moment";

/** "just now", "4 min ago", "3 h ago", "2 d ago", else a short date. */
export function timeAgo(iso) {
  if (!iso) return "";
  const then = moment(iso);
  if (!then.isValid()) return "";
  const mins = moment().diff(then, "minutes");
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} d ago`;
  return then.format("D MMM");
}

export const fmtDateTime = (iso) => {
  if (!iso) return "";
  const m = moment(iso);
  return m.isValid() ? m.format("D MMM YYYY, HH:mm") : "";
};

/** Display name of a `{ user_id, userName, full_name }` actor; a null
    user_id means a system job produced the item. */
export const actorName = (actor) => {
  if (!actor) return "System";
  return actor.full_name || actor.userName || (actor.user_id ? "A user" : "System");
};
